import { ScheduleSessionCardSkeleton } from './ScheduleSessionCardSkeleton'

type ScheduleListSkeletonProps = {
  itemCount?: number
}

export const ScheduleListSkeleton = ({
  itemCount = 5
}: ScheduleListSkeletonProps) => (
  <div
    className="flex flex-col gap-3 pb-4"
    aria-busy="true"
    aria-label="Carregando programação"
  >
    <ScheduleSessionCardSkeleton highlight />
    {Array.from({ length: itemCount - 1 }).map((_, index) => (
      <ScheduleSessionCardSkeleton key={index} />
    ))}
  </div>
)
